import React, { useState, useEffect } from 'react';
import { IsValidPassword } from "./Password.js";
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../utils/Utils.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import PhoneNumberInput from '../shared/inputs/PhoneNumberInput.js';
import './Register.css';
const Register = (props) => {
  const { t, i18n } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [name, setName] = useState(props.initialName || "");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState(props.initialPhone || "");
  const [fetching, setFetching] = useState(false);
  const [inviteChecked, setInviteChecked] = useState(false);

  // If an invite token is provided, fetch the invited email to pre-fill
  useEffect(() => {
    if (!props.inviteToken || inviteChecked) return;
    setInviteChecked(true);
    fetch(`${API_BASE}/api/invite/${props.inviteToken}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.email) setEmail(data.email); })
      .catch(() => {});
  }, [props.inviteToken, inviteChecked]);

  const submit = (formData) => {
    const password = formData.get("password");
    const confirmPassword  = formData.get("confirm");

    if (!IsValidPassword(password)) {
      setErrorMessage(t("password_requirements"));
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage(t("passwords_do_not_match"));
      return;
    }

    if (!phone_number) {
      setErrorMessage(t("phone_number_required"));
      return;
    }

    setFetching(true);

    fetch(`${API_BASE}/api/auth/register`, {
      method: 'POST',
      body: JSON.stringify({name, email, phone_number, password, invite_token: props.inviteToken || "", language: i18n.language})
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.success) {
        props.onRegisterSuccessfull(data);
      } else {
        setErrorMessage(data.message);
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    })
    .finally(() => {
      setFetching(false);
    });
  }

  const Overlay = () => {
    return (
      <div class="form-overlay">
        <div class="loader"></div>
      </div>
    );
  }

  const language = navigator.language;
  return (
    <div class="form-container">
    {fetching ? <Overlay/>:""}
    <form className="RegisterForm" action={submit}>
      <input name="name" type="text" required
             placeholder={t("name")} value={name}
             onChange={(e) => setName(e.target.value)}/>

      <input name="email" type="text" required
             placeholder={t("email")} value={email}
             readOnly={!!props.inviteToken}
             onChange={(e) => setEmail(e.target.value)}/>

      <PhoneNumberInput
        language={language}
        onChange={setPhoneNumber}
        phoneNumber={phone_number}/>


      <div>
        {t("password_requirements")}
      </div>

      <input name="password" type="password"
             placeholder={t("password")} required/>

      <input name="confirm"  type="password"
             placeholder={t("confirm_password")} required/>

      <button type="submit">{t("register")}</button>

      <ErrorMessage message={errorMessage}/>

      <div className="success-message">Success</div>
      <div className="links">
        <a href="#" onClick={props.onLoginClick}>{t("login")}</a>
      </div>
    </form>
    </div>
  );
}
export default Register;
